import { Container, Row, Col } from 'react-bootstrap';
import '../styles/navbar.scss';

export default function InnerHeader(props){
    return(
        <div className="inner-header">
            <Container>
                <Row>
                    <Col>
                        <div className='nav-breadcrumb'>{props.breadcrumb}</div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='nav-pagetitle'>{props.title}</div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}